import React from 'react';
import classes from './SVGIcons.module.css';

/* eslint-disable max-len */

export const GiftIcon = (props) => (
  <svg
    onClick={props.clicked}
    className={[classes.Icon, classes.GiftIcon, classes[props.type]].join(' ')}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="17.778"
    viewBox="0 0 20 17.778"
  >
    <path
      id="gift-card"
      fill={props.fillColor ? props.fillColor : '#01a2d'}
      d="M18.333 4.444h-2.016a3.016 3.016 0 0 0 .35-1.389A3.059 3.059 0 0 0 13.611 0c-1.444 0-2.379.741-3.578 2.373C8.835.741 7.9 0 6.456 0A3.059 3.059 0 0 0 3.4 3.056a3.016 3.016 0 0 0 .35 1.389H1.667A1.667 1.667 0 0 0 0 6.111v10a1.667 1.667 0 0 0 1.667 1.667h16.666A1.667 1.667 0 0 0 20 16.111v-10a1.667 1.667 0 0 0-1.667-1.667zm-4.722-2.777a1.389 1.389 0 1 1 0 2.778h-2.988c1.783-2.656 2.277-2.778 2.988-2.778zM5.067 3.056a1.39 1.39 0 0 1 1.389-1.389c.692 0 1.2.114 2.989 2.778H6.456a1.391 1.391 0 0 1-1.389-1.389zM7.71 6.111l-1.8 1.8a.556.556 0 0 0 0 .786l.393.393a.556.556 0 0 0 .786 0L10 6.178l2.907 2.907a.556.556 0 0 0 .786 0l.393-.393a.556.556 0 0 0 0-.786l-1.8-1.8h6.044v5H1.667v-5zm-6.044 10v-2.778h16.667v2.778z"
    />
  </svg>
);

export const GalleryIcon = (props) => (
  <svg
    onClick={props.clicked}
    className={[classes.Icon, classes.GalleryIcon, classes[props.type], classes[props.className]].join(' ')}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="18"
    viewBox="0 0 24 18"
  >
    <path
      id="prefix__Path_1646"
      fill={props.fillColor ? props.fillColor : '#01a2d'}
      d="M21.75 3H2.25a2.17 2.17 0 0 0-1.594.656A2.17 2.17 0 0 0 0 5.25v13.5a2.17 2.17 0 0 0 .656 1.594A2.17 2.17 0 0 0 2.25 21h19.5A2.241 2.241 0 0 0 24 18.75V5.25A2.241 2.241 0 0 0 21.75 3zm.75 15.75a.722.722 0 0 1-.75.75H2.25a.722.722 0 0 1-.75-.75V5.25a.722.722 0 0 1 .75-.75h19.5a.722.722 0 0 1 .75.75zM5.25 10.875A2.526 2.526 0 0 0 7.1 10.1a2.6 2.6 0 0 0 0-3.7 2.526 2.526 0 0 0-1.85-.775A2.526 2.526 0 0 0 3.4 6.4a2.6 2.6 0 0 0 0 3.7 2.526 2.526 0 0 0 1.85.775zm0-3.75a1.125 1.125 0 1 1-.8 1.922 1.125 1.125 0 0 1 .8-1.922zm9.7 1.078l-4.45 4.453L9.047 11.2a1.132 1.132 0 0 0-1.594 0l-4.125 4.128a1.085 1.085 0 0 0-.328.8v1.313a.56.56 0 0 0 .563.559h16.875a.56.56 0 0 0 .562-.562v-4.313a1.085 1.085 0 0 0-.328-.8L16.547 8.2a1.132 1.132 0 0 0-1.594 0zM19.5 16.5h-15v-.234l3.75-3.75 2.25 2.25 5.25-5.25 3.75 3.75z"
      data-name="Path 1646"
      transform="translate(0 -3)"
    />
  </svg>
);
